import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_web-presence-404/artifacts/dkbqs7vn_logo.png" 
              alt="Ruminating Room" 
              className="h-10 w-10 object-contain"
            />
            <span className="font-light text-lg tracking-wider text-white">
              RUMINATING ROOM
            </span>
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm tracking-wide transition-colors duration-300 ${
                location.pathname === '/'
                  ? 'text-white'
                  : 'text-white/60 hover:text-white'
              }`}
            >
              FASHION
            </Link>
            <Link
              to="/animation"
              className={`text-sm tracking-wide transition-colors duration-300 ${
                location.pathname === '/animation'
                  ? 'text-white'
                  : 'text-white/60 hover:text-white'
              }`}
            >
              ANIMATION
            </Link>
            <a
              href="#contact"
              className="px-6 py-2.5 border border-white/20 text-white text-sm tracking-wide hover:bg-white hover:text-black transition-all duration-300"
            >
              CONTACT
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-white"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className={`text-sm tracking-wide transition-colors duration-300 ${
                  location.pathname === '/'
                    ? 'text-white'
                    : 'text-white/60'
                }`}
              >
                FASHION
              </Link>
              <Link
                to="/animation"
                onClick={() => setMobileMenuOpen(false)}
                className={`text-sm tracking-wide transition-colors duration-300 ${
                  location.pathname === '/animation'
                    ? 'text-white'
                    : 'text-white/60'
                }`}
              >
                ANIMATION
              </Link>
              <a
                href="#contact"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm tracking-wide text-white/60"
              >
                CONTACT
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
